import React, { Component } from "react";

import { CBadge, CListGroup, CListGroupItem } from "@coreui/react";

import TextEditorReadOnly from "../../TextEditorReadOnly/TextEditorReadOnly";

export default class DataQ extends Component {
  getOptionPercentage(questionId, optionId) {
    const { applications } = this.props;

    const sameApplications = applications.filter(application => {
      try {
        const answer = JSON.parse(
          application.answers.find(answer => answer.question_id === questionId)
            .answer
        );

        return answer.itemsAnswer?.answers[0] === optionId;
      } catch (err) {
        return false;
      }
    });

    return (sameApplications.length / applications.length) * 100;
  }

  isDistractor(question, option) {
    const distractorValue = question.options.reduce(
      (acc, val) =>
        Math.max(
          acc,
          val.check_value ? 0 : this.getOptionPercentage(question.id, val.id)
        ),
      0
    );

    if (
      distractorValue > 0 &&
      distractorValue === this.getOptionPercentage(question.id, option.id)
    )
      return true;

    return false;
  }

  render() {
    const { list, applications } = this.props;

    return (
      <>
        {list.questions?.map(question => (
          <div className="p-4 w-100" key={question.id}>
            <p>
              <TextEditorReadOnly
                editorType={{ name: "description", id: 1 }}
                questionId={question.id}
                textContent={question.description}
              />
              <CBadge color="secondary" className="p-2">
                {question.ability_description}
              </CBadge>
            </p>
            <CListGroup>
              {question.options.map(option => (
                <CListGroupItem
                  className={
                    option.check_value
                      ? "bg-success"
                      : this.isDistractor(question, option)
                      ? "list-group-item-warning"
                      : ""
                  }
                  key={option.id}
                  style={{ marginTop: "1px" }}
                >
                  <TextEditorReadOnly
                    editorType={{ name: "description", id: 1 }}
                    questionId={option.id}
                    textContent={option.description}
                    style={{ margin: 0 }}
                  />
                  A porcentagem de estudantes que marcaram essa alternativa foi
                  de:{" "}
                  <strong>
                    {this.getOptionPercentage(question.id, option.id).toFixed(
                      2
                    )}
                    %
                  </strong>
                </CListGroupItem>
              ))}
            </CListGroup>
          </div>
        ))}
      </>
    );
  }
}
